module.exports = __webpack_public_path__ + "media/icons/download-google-play-light-8aaffaa4.svg";